






































import Vue from 'vue'
import { PropValidator } from 'vue/types/options'
import { IDevice } from '@/types/model'
import CheckboxIcon from '@/components/CheckboxIcon.vue'
import HpdIcon from '@/components/HpdIcon.vue'
import AliveIndicator from '@/components/AliveIndicator.vue'
import PreviewScreen from '@/components/PreviewScreen.vue'
import DeviceTypeIcon from '@/components/DeviceTypeIcon.vue'
import DeviceVendorIcon from '@/components/DeviceVendorIcon.vue'
import easyapi from '@/easyapi'
import mixins from 'vue-typed-mixins'
import { vuetifyThemeAware } from '@/mixins'
import { getExtenderActiveUsage, ExtenderActiveStateSummary } from '@/utils'

export default mixins(vuetifyThemeAware).extend({
  components: {
    PreviewScreen,
    CheckboxIcon,
    HpdIcon,
    DeviceTypeIcon,
    DeviceVendorIcon,
    AliveIndicator,
  },
  props: {
    checked: {
      type: Boolean
    },
    device: {
      type: Object
    } as PropValidator<IDevice>,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    usage (): ExtenderActiveStateSummary { return getExtenderActiveUsage(this.$state, this.device) },
    previewScreenMaxWidth (): number { return this.$state.common.windowSize.width - 260 },
    isDesktop (): boolean { return this.$state.common.windowSize.width > 770 },  // (800 x 600) - 30px
  },
  methods: {
    blinkLed () { easyapi.blinkLed(this, this.device) },
    openDeviceRenameDialog () { this.$router.push({ name: 'matrix_remap_rename', params: {mac: this.device.mac} }) },
    checkThisDevice () {
      if (!this.disabled) {
        this.$emit('checked', this.device)
      }
    }
  }
})
